<ng-container *ngIf="multiple; else single">
  <div class="iris-dropdown-container iris-dropdown-animation-container">
    <button
      id="iris-dropdown-button"
      class="iris-dropdown iris-dropdown--multi"
      [ngClass]="{
        'placeholder': !control.value.length,
        'invalid': control.touched | isControlInvalidAndTouched:control.invalid
      }"
      (click)="expandClickMultiMenu($event)"
      (keydown)="handleMultiKeyDown($event)"
      (keyup.escape)="escapeMenu($event)"
      (blur)="onBlur($event)"
      [attr.aria-describedby]="formControlName
        && (control.touched | isControlInvalidAndTouched:control.invalid)
          ? formControlName + '-error-messages' : null"
      [attr.aria-expanded]="isExpanded"
      [attr.aria-invalid]="control.touched | isControlInvalidAndTouched:control.invalid"
      [attr.required]="(control | isControlRequired) || null"
      [attr.data-test]="dataTestId"
      aria-haspopup="listbox"
      [disabled]="control.disabled"
      #dropdown
    >
      <div class="iris-dropdown-inner-container" data-test="iris-dropdown-inner-container">
        <span *ngIf="placeholder && !currentSelections.length" class="placeholder-text">{{ placeholder }}</span>
        <span
          *ngFor="let tag of visibleTags"
          class="iris-dropdown-item-tag"
          data-test="iris-dropdown-item-tag"
        >
          {{ tag.name }}
          <iris-icon
            name="close"
            class="delete-icon"
            (click)="onTagClick(tag)"
            [size]="iconSizes.SM"
            [usage]="iconUsageTypes.DECORATIVE"
            data-test="delete-icon"
          ></iris-icon>
        </span>
        <span *ngIf="overflowTags.length" class="iris-dropdown-overflow-count">
          (+{{ overflowTags.length }} other{{ overflowTags.length > 1 ? 's' : '' }})
        </span>
        <iris-icon
          name="arrow_drop_down"
          class="iris-dropdown-toggle"
          [usage]="iconUsageTypes.DECORATIVE"
          [color]="(control.touched | isControlInvalidAndTouched:control.invalid) ? iconColors.DANGER : iconColors.BRAND1"
        ></iris-icon>
      </div>

      <!-- Hidden container is used to detect item tag overflow from current selections -->
      <div class="iris-dropdown-hidden-wrapper" [attr.aria-hidden]="true">
        <div class="iris-dropdown-resize-container" [ngStyle]="{'visibility': 'hidden'}" #hiddenContainer>
          <span *ngFor="let tag of hiddenTags" class="iris-dropdown-item-tag">
            {{ tag.name }}
            <iris-icon
              name="close"
              class="delete-icon"
              [size]="iconSizes.SM"
              [usage]="iconUsageTypes.DECORATIVE"
            ></iris-icon>
          </span>
          <span *ngIf="overflowTags.length" class="iris-dropdown-overflow-count">
            (+{{ overflowTags.length }} other{{overflowTags.length > 1 ? 's' : ''}})
          </span>
        </div>
      </div>
    </button>
  
    <div
      [ngClass]="{'hidden': !isExpanded, 'drop-up': shouldDropUp}"
      class="iris-dropdown-listbox"
      [attr.aria-multiselectable]="true"
      role="listbox"
      #listbox
    >
      <div
        *ngIf="canSelectAll"
        class="iris-dropdown-list-item select-all"
        [ngClass]="{'selected': selectAllToggleActive}"
        [id]="formControlName + '-dropdown-option-select-all'"
        (mousedown)="$event.preventDefault()"
        (click)="toggleSelectAll()"
        (keydown)="handleMultiKeyDown($event)"
        (keyup.escape)="escapeMenu($event)"
        (blur)="onBlur($event)"
        (mouseenter)="onHoverEnter('select-all')"
        (mouseleave)="onHoverLeave()"
        [attr.aria-selected]="control.value.length === options.length"
        role="option"
        tabindex="-1"
      >
        <div class="iris-checkbox" (blur)="onBlur($event)">
          <div
            class="iris-checkbox-highlight-circle"
            [ngClass]="{'show-highlight': currentFocusedValue === 'select-all' || currentHoveredValue === 'select-all'}"
          ></div>
          <div
            class="iris-checkbox-box"
            [ngClass]="{
              'is-checked': selectAllToggleActive,
              'is-highlighted': currentFocusedValue === 'select-all' || currentHoveredValue === 'select-all'
            }"
            (blur)="onBlur($event)"
          >
            <div
              *ngIf="selectAllToggleActive && control.value.length === options.length"
              class="iris-checkmark"
              (blur)="onBlur($event)"
            >
              <div class="iris-checkmark-right iris-checkmark-half" (blur)="onBlur($event)"></div>
              <div class="iris-checkmark-left iris-checkmark-half" (blur)="onBlur($event)"></div>
            </div>
            <div
              *ngIf="selectAllToggleActive && control.value.length < options.length"
              class="iris-indeterminate"
              (blur)="onBlur($event)"
            ></div>
          </div>
        </div>
        Select all
      </div>
      <div
        *ngFor="let option of options; let i = index"
        class="iris-dropdown-list-item"
        [ngClass]="{'selected': option.value && (control.value | isOptionSelected:option.value)}"
        [id]="formControlName + '-dropdown-option' + i"
        (mousedown)="$event.preventDefault()"
        (click)="changeMultiSelection(option)"
        (keydown)="handleMultiKeyDown($event)"
        (keyup.escape)="escapeMenu($event)"
        (blur)="onBlur($event)"
        (mouseenter)="onHoverEnter(option.value)"
        (mouseleave)="onHoverLeave()"
        [attr.aria-selected]="(control.value | isOptionSelected:option.value)"
        [attr.aria-label]="option.name"
        [attr.data-test]="'insurance-option-' + option.value"
        role="option"
        tabindex="-1"
      >
        <div class="iris-checkbox" (blur)="onBlur($event)">
          <div
            class="iris-checkbox-highlight-circle"
            [ngClass]="{'show-highlight': currentFocusedValue === option.value || currentHoveredValue === option.value}"
          ></div>
          <div
            class="iris-checkbox-box"
            [ngClass]="{
              'is-checked': option.value && (control.value | isOptionSelected:option.value),
              'is-highlighted': currentFocusedValue === option.value || currentHoveredValue === option.value
            }"
            (blur)="onBlur($event)"
          >
            <div class="iris-checkmark" (blur)="onBlur($event)">
              <div class="iris-checkmark-right iris-checkmark-half" (blur)="onBlur($event)"></div>
              <div class="iris-checkmark-left iris-checkmark-half" (blur)="onBlur($event)"></div>
            </div>
          </div>
        </div>
        {{ option.name }}
      </div>
    </div>
  </div>
</ng-container>

<ng-template #single>
  <div class="iris-dropdown-container iris-dropdown-animation-container">
    <button
      data-test="intake-dropdown"
      [ngClass]="{
        'iris-dropdown': true,
        'iris-dropdown-filter-style': dropdownType === dropdownFilterType,
        'placeholder': !control.value,
        'invalid': control.touched | isControlInvalidAndTouched:control.invalid
      }"
      (click)="expandClickMenu($event); $event.stopPropagation(); $event.preventDefault()"
      (keydown)="handleKeyDown($event)"
      (keyup.escape)="escapeMenu($event)"
      (blur)="onBlur($event)"
      [attr.aria-describedby]="formControlName
        && (control.touched | isControlInvalidAndTouched:control.invalid)
          ? formControlName + '-error-messages' : null"
      [attr.aria-expanded]="isExpanded"
      [attr.aria-invalid]="control.touched | isControlInvalidAndTouched:control.invalid"
      [attr.required]="(control | isControlRequired) || null"
      aria-haspopup="listbox"
      [disabled]="control.disabled"
      #dropdown
    >
      {{ currentSelection?.name || placeholder }}
      <iris-icon
        name="arrow_drop_down"
        class="iris-dropdown-toggle"
        [usage]="iconUsageTypes.DECORATIVE"
        [color]="(control.touched | isControlInvalidAndTouched:control.invalid) ? iconColors.DANGER : iconColors.BRAND1"
      ></iris-icon>
    </button>
  
    <div
      [ngClass]="{'hidden': !isExpanded, 'drop-up': shouldDropUp}"
      class="iris-dropdown-listbox"
      role="listbox"
      #listbox
    >
      <div
        *ngFor="let option of options; let i = index"
        class="iris-dropdown-list-item"
        [ngClass]="{'selected': option.value && control.value == option.value}"
        [id]="formControlName + '-dropdown-option' + i"
        (mousedown)="$event.preventDefault()"
        (click)="changeSelection(option)"
        (keydown)="handleKeyDown($event)"
        (keyup.escape)="escapeMenu($event)"
        (blur)="onBlur($event)"
        [attr.aria-selected]="control.value == option.value"
        [attr.aria-label]="option.name || 'Empty'"
        role="option"
        tabindex="-1"
        [attr.data-test]="'option-' + option.value"
      >
        {{ option.name }}
      </div>
    </div>
  </div>
</ng-template>
